import { PageHeader } from "@/components/page";
import { TenantDashboard } from "@/components/page/TenantDashboard";
import { useTenant } from "@/hooks/routes/useTenant";

export const DashboardPage = () => {
  const { tenant } = useTenant();
  if (!tenant) return null;
  return (
    <div className="flex flex-col flex-grow w-0">
      <PageHeader
        title={tenant.name ? `${tenant.name}'s Dashboard` : "Dashboard"}
      ></PageHeader>
      <TenantDashboard tenantId={tenant.id} />
    </div>
  );
};
